module.exports = __webpack_public_path__ + "img/image-thumb-4.cd4692f5.jpg";